import React from 'react';
import PropTypes from 'prop-types';

import Radio from '@material-ui/core/Radio';
import RadioGroup from '@material-ui/core/RadioGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Typography from '@material-ui/core/Typography';

import Styles from './StartWithSelector.module.css';

const View = ({ onChange, value }) => (
	<div className={Styles.container}>
        <fieldset>
            <legend className="lblRadioGroup">Start By:</legend>
            <RadioGroup role="radio" aria-label="starts with" name="startsWith" labelId="start-by-label" row value={value} onChange={onChange} className={Styles.content}>
			    <FormControlLabel value="Type" control={<Radio />} label="Type" className={value === 'Type' ? Styles.selected : ''} />
                <FormControlLabel value="Team" control={<Radio />} label="Team" className={value === 'Team' ? Styles.selected : ''} />
                </RadioGroup>
        </fieldset>
	</div>
);

View.propTypes = {
	onChange: PropTypes.func.isRequired,
	value: PropTypes.string.isRequired
};

export default View;
